import React from "react";
import { CalendarDays, AlarmClock, AlertTriangle, MessageSquareReply, CalendarClock, CheckCircle2, UserX, Flame, Hourglass } from "lucide-react";

const MINE = [
  { key: "today", label: "Heute fällig", icon: CalendarDays, color: "#D97706" },
  { key: "overdue", label: "Überfällig", icon: AlarmClock, color: "#DC2626" },
  { key: "defects", label: "Offene Mängel", icon: AlertTriangle, color: "#EF4444" },
  { key: "feedback", label: "Offene Rückmeldungen", icon: MessageSquareReply, color: "#7C3AED" },
  { key: "upcoming", label: "Demnächst (7 Tage)", icon: CalendarClock, color: "#0284C7" },
  { key: "done", label: "Abgeschlossen", icon: CheckCircle2, color: "#16A34A" },
];
const TEAM = [
  { key: "unassigned", label: "Nicht zugewiesen", icon: UserX, color: "#64748B" },
  { key: "overdue", label: "Überfällig", icon: AlarmClock, color: "#DC2626" },
  { key: "today", label: "Heute fällig", icon: CalendarDays, color: "#D97706" },
  { key: "high", label: "Hoch / Kritisch", icon: Flame, color: "#EA580C" },
  { key: "stale", label: "Ohne Bearbeitung", icon: Hourglass, color: "#0D9488" },
  { key: "feedback", label: "Rückmeldungen", icon: MessageSquareReply, color: "#7C3AED" },
];

export default function TaskKpis({ counts, active, onPick, team, doneDays }) {
  const defs = team ? TEAM : MINE;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-3" data-testid={team ? "team-kpis" : "task-kpis"}>
      {defs.map((d) => {
        const on = active === d.key;
        return (
          <button key={d.key} onClick={() => onPick(on ? "open" : d.key)} data-testid={`task-kpi-${d.key}`}
            className={`text-left bg-white border rounded-xl p-3.5 relative overflow-hidden transition-[box-shadow,border-color] hover:shadow-md ${on ? "border-primary ring-2 ring-primary/20" : "border-slate-200"}`}>
            <div className="absolute top-0 left-0 right-0 h-1" style={{ background: d.color }} />
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="text-2xl font-head font-extrabold font-mono-tech text-slate-900" data-testid={`task-kpi-${d.key}-value`}>{counts?.[d.key] ?? 0}</div>
                <div className="text-xs text-slate-500 mt-0.5 leading-tight">{d.label}{d.key === "done" ? ` (${doneDays} T.)` : ""}</div>
              </div>
              <d.icon className="h-4 w-4 shrink-0" style={{ color: d.color }} />
            </div>
          </button>
        );
      })}
    </div>
  );
}
